import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../components/generic/Modal';
import { useCloneParticipantNoteMutation } from '../../graphql/hooks/useCloneParticipantNoteMutation';
import { useAppContext } from '../../hooks/useAppContext';

interface Props {
  participantId: string;
  participantNoteId: string;
}

export const ParticipantNoteCloneModal = createModal<Props>((props) => {
  const { participantId, participantNoteId, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const { hide, remove, visible } = modal;

  const mutation = useCloneParticipantNoteMutation();

  const onClone = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        participantNoteId,
      })
      .then(() => {
        successToast('Note cloned successfully');
        hide();
      })
      .catch((err) => {
        errorToast(`Error cloning note: ${err.message}`);
      });
  }, [mutation, organization.id, participantId, participantNoteId, successToast, hide, errorToast]);

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle title='Do you want to clone this note?' />
          <ChakraV3.Dialog.Footer>
            <ChakraV3.Button onClick={hide} key='close' variant='subtle'>
              Close
            </ChakraV3.Button>
            <ChakraV3.Button
              onClick={async () => onClone()}
              key='clone'
              colorPalette='brand'
              size='sm'
              loading={mutation.isLoading}
              loadingText='Cloning...'
              type='submit'
            >
              Clone
            </ChakraV3.Button>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
